import { Link } from 'react-router-dom'

import styles from './NavBar.module.css'

const NavBar = (props) => {

    return (
        <div className={styles.container}>
            <nav className={styles.nav_principal}>
                <div></div>
                <div className={styles.nav_links}>
                    <Link to="/home" className={styles.logoname}><span>Taskin</span></Link>
                </div>
                <Link className={styles.logout} onClick={props.handleLogout} to="/"><span>{props.professionalName && props.professionalName} - Logout</span><i className="fa-solid fa-right-from-bracket"></i></Link>
            </nav>
        </div>
    )
}

export default NavBar
